import { defineStore } from 'pinia';
import { reactive } from 'vue';

export let store = {};

export let stacks = [];

export let useMainStore = null;

export function createMainStore( response ) {
	useMainStore = defineStore(
		`main`,
		{
			state: () => response
		}
	);
};

export function create_store( response ) {
	store = reactive(
		response
	);

	stacks = reactive( [] );

	return store;
}

export function add_to_stack( key, priority, close_func ) {
	stacks.push(
		{
			key,
			priority,
			close: close_func,
			removed: false
		}
	);
}

export function remove_from_stack( key ) {
	const stack = stacks.find( s => s.key === key );
	if( stack ) {
		stack.removed = true;
	}
}


